var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:location",
    filter: "url(#filter0_d_102_1122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6136 20.9999C22.0907 20.9999 21.3562 20.8108 20.2564 20.1963C18.919 19.4463 17.8845 18.7539 16.5543 17.4272C15.2718 16.1455 14.6477 15.3156 13.7742 13.7261C12.7874 11.9315 12.9556 10.9908 13.1436 10.5887C13.3676 10.1082 13.6981 9.82074 14.1253 9.53547C14.368 9.37648 14.6248 9.24019 14.8925 9.12832C14.9193 9.11681 14.9442 9.10582 14.9664 9.09591C15.099 9.03618 15.2999 8.94591 15.5544 9.04234C15.7242 9.10609 15.8758 9.23654 16.1131 9.47092C16.5998 9.95092 17.2649 11.02 17.5103 11.545C17.675 11.8988 17.784 12.1324 17.7843 12.3943C17.7843 12.701 17.63 12.9376 17.4428 13.1928C17.4077 13.2408 17.3729 13.2866 17.3391 13.3311C17.1353 13.5989 17.0905 13.6763 17.12 13.8145C17.1797 14.0923 17.6252 14.9192 18.3573 15.6497C19.0893 16.3801 19.8924 16.7974 20.1712 16.8569C20.3153 16.8877 20.3943 16.8411 20.6708 16.63C20.7104 16.5998 20.7511 16.5684 20.7937 16.5371C21.0793 16.3247 21.3048 16.1744 21.6043 16.1744H21.6059C21.8665 16.1744 22.0896 16.2874 22.4593 16.4739C22.9414 16.7171 24.0426 17.3736 24.5255 17.8608C24.7605 18.0976 24.8914 18.2487 24.9555 18.4183C25.0519 18.6735 24.9611 18.8736 24.9019 19.0076C24.892 19.0298 24.881 19.0542 24.8695 19.0812C24.7567 19.3484 24.6196 19.6047 24.4599 19.8468C24.1752 20.2727 23.8867 20.6024 23.4051 20.8266C23.1578 20.9436 22.8871 21.0028 22.6136 20.9999Z",
    fill: "#0D4672"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_1122",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_1122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_1122",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallRound);
export default __webpack_public_path__ + "static/media/callRound.c668883fa3fe2b62e284a33c5a6ed366.svg";
export { ForwardRef as ReactComponent };